import HttpReq from '../../../service/httpReq';
import { PathFactory } from '../utils';
import {
    notificationListResponseSchema,
    NotificationListResponseSchemaType,
    unreadCountResponseSchema,
    UnreadCountResponseSchemaType,
    voidResponseSchema,
    VoidResponseSchemaType,
} from './schemas';

class NotificationsRepo {
    static publicPath = 'api/mgmt/notifications';

    static getAll(
        successConsumer: (response: NotificationListResponseSchemaType) => void,
        errorConsumer?: (...args: any[]) => void
    ) {
        HttpReq.get(
            NotificationsRepo.publicPath,
            (response: unknown) => {
                successConsumer(notificationListResponseSchema.parse(response));
            },
            errorConsumer
        );
    }

    static getUnreadCount(
        successConsumer: (response: UnreadCountResponseSchemaType) => void,
        errorConsumer?: (...args: any[]) => void
    ) {
        HttpReq.get(
            PathFactory.create([NotificationsRepo.publicPath, 'unread-count']),
            (response: unknown) => {
                successConsumer(unreadCountResponseSchema.parse(response));
            },
            errorConsumer
        );
    }

    static markAsRead(
        id: number,
        successConsumer: (response: VoidResponseSchemaType) => void,
        errorConsumer?: (...args: any[]) => void
    ) {
        HttpReq.patch(
            PathFactory.create([NotificationsRepo.publicPath, id]),
            { isRead: true },
            (response: unknown) => {
                successConsumer(voidResponseSchema.parse(response));
            },
            errorConsumer
        );
    }

    static markAsUnread(
        id: number,
        successConsumer: (response: VoidResponseSchemaType) => void,
        errorConsumer?: (...args: any[]) => void
    ) {
        HttpReq.patch(
            PathFactory.create([NotificationsRepo.publicPath, id]),
            { isRead: false },
            (response: unknown) => {
                successConsumer(voidResponseSchema.parse(response));
            },
            errorConsumer
        );
    }

    static markAllAsRead(
        successConsumer: (response: VoidResponseSchemaType) => void,
        errorConsumer?: (...args: any[]) => void
    ) {
        HttpReq.patch(
            NotificationsRepo.publicPath,
            { isRead: true },
            (response: unknown) => {
                successConsumer(voidResponseSchema.parse(response));
            },
            errorConsumer
        );
    }

    static deleteAllRead(
        successConsumer: (response: VoidResponseSchemaType) => void,
        errorConsumer?: (...args: any[]) => void
    ) {
        HttpReq.delete(
            PathFactory.create([NotificationsRepo.publicPath, 'read']),
            (response: unknown) => {
                successConsumer(voidResponseSchema.parse(response));
            },
            errorConsumer
        );
    }
}

export default NotificationsRepo;
